<template class="full-height">
  <div class="member-container full-height">
    <el-dialog
      :top="dialogTopMargin"
      v-loading="listLoading"
      :visible.sync="dialogFormVisible"
      :title="hashtagData.id ? '編輯' : '新增'"
    >
      <el-card class="box-card">
        <el-form size="mini" ref="hashTagForm" :model="hashtagData" :label-width="formLabelWidth">
          <el-form-item
            :label="'hashtag'"
            prop="title"
            :rules="[{ required: true, message: '請輸入hashtag', trigger: 'blur' }]"
          >
            <el-input v-model="hashtagData.title"></el-input>
          </el-form-item>

          <el-form-item
            :label="'排序'"
            prop="sort"
            :rules="[{ required: true, message: '請輸入排序', trigger: 'blur' }]"
          >
            <el-input v-model.number="hashtagData.sort" type="number"></el-input>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData('hashTagForm')">確定</el-button>
        <el-button type="danger" @click="dialogFormVisible = !dialogFormVisible">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :top="dialogTopMargin"
      v-loading="listLoading"
      :visible.sync="dialogDetailVisible"
      :title="'查看【' + searchTitle + '】搜尋紀錄'"
      width="30%"
    >
      <el-card class="box-card">
        <el-table :data="searchTableData" style="width: 100%">
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="buildDate" label="日期" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.buildDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="buildUserID" label="身分" align="center" width="180">
            <template slot-scope="{ row }">
              <span>{{ row.buildUserID == 0 ? '一般訪客' : '會員-' + row.userName }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogDetailVisible = !dialogDetailVisible"
          >關閉</el-button
        >
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-form :inline="true">
          <el-form-item label="關鍵字搜尋">
            <el-input
              size="mini"
              v-model="listQuery.qry"
              placeholder="輸入查詢"
              @keyup.enter.native="handleFilter"
            />
          </el-form-item>

          <el-form-item label="日期區間">
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              @click="handleFilter"
            >
              搜尋
            </el-button>

            <el-button type="success" size="mini" @click="addData">建立</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'hashtag'" prop="title" align="left" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.title }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'被搜尋次數'"
            prop="searchCount"
            sortable="custom"
            align="left"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.searchCount }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'文章內使用次數'"
            prop="count"
            sortable="custom"
            align="left"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.count }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'排序'" prop="sort" sortable="custom" align="left" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.sort }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'查看搜尋紀錄'" width="180">
            <template slot-scope="scope">
              <el-button size="mini" class="filter-item" type="success" @click="detail(scope.row)">
                查看搜尋紀錄
              </el-button>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'編輯'" width="130">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="primary"
                @click="editData(scope.row)"
              >
                編輯
              </el-button>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            :label="'刪除'"
            width="130"
            v-if="checkPermission(['ITA-DEV'])"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="danger"
                @click="deleteHashTag(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        style="padding-top: 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { deleteHashTag, getHashTag, getHashTagSearch, saveHashTag } from '@/api/tcSetting'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination

import checkPermission from '@/utils/permission' // 权限判断函数
import { nextTick } from 'process'
var defaultFormData = {
  id: null,
  title: '',
}
export default {
  name: 'HashTag',
  components: { Pagination },
  directives: { waves },
  filters: {},
  data() {
    return {
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      dialogFormVisible: false,
      dialogDetailVisible: false,
      hashtagData: {},
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 30,
        sort: '+Sort,-count',
        date: null,
      },
      searchTitle: '',
      searchTableData: null,
      dateValue: null,
    }
  },
  async created() {
    await this.getList()
  },
  methods: {
    async deleteHashTag(row) {
      console.log(row.id)
      let vm = this
      this.$confirm('確定刪除該筆資料?', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          vm.loadingHanlder(true)

          let resp = await deleteHashTag({ id: row.id })
          if (resp.success) {
            await vm.getList()
            vm.$message({
              message: '操作成功',
              type: 'success',
            })
          }
          vm.loadingHanlder(false)
        })
        .catch(err => {
          console.error(err)
        })
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    checkPermission,

    addData(row) {
      let vm = this
      vm.hashtagData = JSON.parse(JSON.stringify(defaultFormData))
      vm.dialogFormVisible = true
      nextTick(() => {
        this.$refs['hashTagForm'].clearValidate()
      })
    },
    async detail(row) {
      this.searchTitle = row.title
      await getHashTagSearch(row.id)
        .then(resp => {
          console.log(resp)
          this.searchTableData = resp.data
        })
        .catch(error => {
          console.log(error)
        })
      this.dialogDetailVisible = true
    },
    editData(row) {
      let vm = this
      vm.hashtagData = row
      vm.dialogFormVisible = true
    },
    saveData(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loadingHanlder(true)
          saveHashTag(vm.hashtagData)
            .then(async response => {
              console.log(response)
              await vm.getList()
              vm.dialogFormVisible = false
              this.loadingHanlder(false)
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            })
            .catch(error => {
              console.log(error.response.data)
              this.loadingHanlder(false)
            })
        } else {
          return false
        }
      })
    },

    async getList() {
      this.loadingHanlder(true)
      var res = await getHashTag(this.listQuery)
      console.log(res)
      this.list = res.data.data
      this.total = res.data.total
      this.loadingHanlder(false)
    },
    handleFilter() {
      this.listQuery.date = null
      if (this.dateValue !== null && this.dateValue.length > 0) {
        this.listQuery.date = this.dateValue.toString()
      }
      this.listQuery.page = 1
      this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}
</style>
